angular.module('leanlaw').controller('ReceivablesReportCtrl', ['$scope', '$rootScope', '$q', '$window', '$filter', '$timeout', '$stateParams', '$state', "alerts", 'userService', 'reportsService', 'commonFilterService', "exportJson", "singleRequest", "messageBus", function ($scope, $rootScope, $q, $window, $filter, $timeout, $stateParams, $state, alerts, userService, reportsService, commonFilterService, exportJson, singleRequest, messageBus) {
  $scope.clients = {};
  $scope.data = {
    clients: null,
    filteredClients: null
  };
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.print = function () {
    $window.print();
  };
  $scope.export = function () {
    const currencyFilter = $filter('amount');
    function makeRow(item, id, responsible, isMatter) {
      let row = {};
      if ($scope.clientReferences || $scope.references) {
        if (!isMatter) {
          row = {
            ID: id,
            Client: item.client.name,
            Matter: ""
          };
        } else {
          row = {
            ID: id,
            "Client": "",
            Matter: item.matter.name
          };
        }
      } else {
        if (!isMatter) {
          row = {
            "Client": item.client.name,
            Matter: ""
          };
        } else {
          row = {
            "Client": "",
            Matter: item.matter.name
          };
        }
      }
      row.Responsible = responsible;
      if ($scope.filter.include && $scope.filter.include.billingInstructions) {
        var instructions = isMatter ? item.matter.billingInstructions : item.client.billingInstructions;
        row["Billing Instructions"] = !$scope.filter.include.matters || isMatter ? instructions : '';
      }
      row["Account Balance"] = currencyFilter(item.data.accounting.balance, '$', 2);
      row["Current"] = currencyFilter(item.data.accounting.aging.current, '$', 2);
      row["1-30 Days"] = currencyFilter(item.data.accounting.aging.under30, '$', 2);
      row["31-60 Days"] = currencyFilter(item.data.accounting.aging.over30, '$', 2);
      row["61-90 Days"] = currencyFilter(item.data.accounting.aging.over60, '$', 2);
      row["> 90 Days"] = currencyFilter(item.data.accounting.aging.over90, '$', 2);
      return row;
    }
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      const responsible = $scope.filter.include?.matters && c.matters.length ? '' : c.responsibles.map(a => a.initials || a.name).join('\n');
      accum.push(makeRow(c, c.client.reference || "", responsible, false));
      if ($scope.filter.include && $scope.filter.include.matters) {
        c.matters.forEach(m => {
          const reference = m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '';
          const matterResponsible = m.matter.primary ? m.matter.primary.initials || m.matter.primary.name : '';
          accum.push(makeRow(m, reference, matterResponsible, true));
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp, 'Receivables');
  };
  $scope.loading = true;
  userService.me().then(me => {
    $scope.trust = me.company.settings.trustEnabled;
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      $scope.filter.billedState = $scope.filter.billedFilter && $scope.filter.billedFilter.id;
      // if (payload.filter.range) filterClientEntries();
      debouncedFilterClientEntries();
    });
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
      debouncedFilterClientEntries();
    });
    $scope.$on("report-clientmatter-change", (event, cm) => {
      singleRequest.cancel("clientEntries");
      $scope.goToReceivablesInvoice(cm.client?.id, cm.matter?.id);
    });
    $scope.$watch('filter.include.accounting', show => {
      if (show) {
        debouncedFilterClientEntries();
      }
    }, true);

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
    messageBus.addMessage("clientmatter-set", true, {});
  });

  // Debounce filterClientEntries to prevent multiple rapid calls
  function debouncedFilterClientEntries() {
    if ($scope.filterTimeout) {
      $timeout.cancel($scope.filterTimeout);
    }
    $scope.filterTimeout = $timeout(() => {
      filterClientEntries();
    }, 100); // 100ms debounce
  }
  function filterClientEntries() {
    // Cancel any previous requests
    singleRequest.cancel("receivables");
    $scope.loading = true;
    $scope.data = {
      clients: null,
      filteredClients: null
    };
    const query = reportsService.queryFromFilter($scope.filter);
    // filter hides the date range but still slips through in the query, so scrum them here 
    query.startDate = undefined;
    query.endDate = undefined;
    query.primary = 'clients';
    query.data = "receivables,aging";
    query.zeros = false;
    singleRequest.apiCall("receivables", true).getReport(query).then(data => {
      if (!data) return;
      $scope.data = data;
      const {
        clients
      } = data;
      $scope.clientReferences = clients.some(c => c.client.reference);
      $scope.references = clients.some(c => c.matters.some(m => m.matter.reference));
      clients.forEach(client => {
        const responsible = client.matters.reduce((acc, m) => {
          if (!m.matter.primary) return acc;
          acc[m.matter.primary.id] = m.matter.primary;
          return acc;
        }, {});
        client.responsibles = Object.keys(responsible).map(id => responsible[id]);
        const instructions = client.matters.reduce((acc, m) => {
          if (m.matter.billingInstructions) acc.push(m.matter.billingInstructions);
          return acc;
        }, []);
        client.client.billingInstructions = instructions.length ? instructions.join("\n") : "";
      });
      $scope.total = _.reduce(clients, (sum, c) => {
        const {
          aging,
          balance
        } = c.data.accounting;
        return {
          balance: sum.balance + (balance || 0.0),
          current: sum.current + aging.current,
          under30: sum.under30 + aging.under30,
          over30: sum.over30 + aging.over30,
          over60: sum.over60 + aging.over60,
          over90: sum.over90 + aging.over90
        };
      }, {
        balance: 0,
        current: 0,
        under30: 0,
        over30: 0,
        over60: 0,
        over90: 0
      });
      updateFiltered();
      $scope.loading = false;
    }).catch(() => {
      alerts.error('Failed to load receivables data. Please try again.');
      $scope.loading = false;
      $scope.data = {
        clients: [],
        filteredClients: []
      };
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("receivables");
    deactivate();
  });
  $scope.goToReceivablesInvoice = (clientId, matterId) => {
    $state.go("reports.receivables-invoices-list", {
      clientId,
      matterId,
      return: "reports.receivables",
      report: `Receivables`
    });
  };

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    const {
      data
    } = $scope;
    if (!data || !data.clients) {
      if (data) data.filteredClients = [];
      return;
    }
    data.filteredClients = $filter('orderBy')($filter('filter')(data.clients, $scope.search), $scope.sort, $scope.reverse);
    data.filteredClients.forEach(client => {
      client.filteredMatters = $filter('orderBy')(client.matters, $scope.sort, $scope.reverse);
    });
  }
  $scope.$watch("search", updateFiltered);
  $scope.$watchGroup(["sort", "reverse"], updateFiltered);
}]);